<template>
  <div class="block-wrap block-specification" style="padding: 10px">
    <div v-for="(s, sindex) in specifications" :key="sindex">
      <el-form class="title-bg" ref="skuForm" :model="s" inline>
        规格名：
        <template>
          <el-input
            style="width: 140px"
            :disabled="s.salePropType === 'preset' && s.nameConfigRule.required"
            v-model="s.name"
            :maxlength="s.nameConfigRule.maxLength || 20"
            @keyup.enter.native="e => nameEnter(sindex)"
            @change="e => nameChange(s)"
          ></el-input>
        </template>
        <el-button
          v-if="remarkKey && s.valueConfigRule.remarkRule && s.valueConfigRule.remarkRule.supportRemark"
          style="float: right; margin-right: 8px"
          type="link"
          @click="openBatchRemarkDialog(s.name)">批量设置规格备注</el-button>
      </el-form>
      <div v-if="showAddSkuTips && sindex === 0 && !isGroupPuhuo" class="add-sku-tips">
        <div>如需添加新的规格值,请至<el-link @click="changeToBase">【基础资料】</el-link>进行添加</div>
        <span @click="handleNoTips" class="tips-btn">不再提示</span>
      </div>
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left: 10px">规格值：</div>
        <vue-draggable
          class="specification-value-flex"
          v-model="s.values"
          filter=".drag-ignore_item"
          handle=".drag-icon-wrap"
          :group="{ name: s.name, pull: 'clone', put: false }"
          :animation="500"
        >
          <div v-for="(v, vi) in s.values" :key="v.valueKey" class="specification-value-flex_item">
            <el-form ref="specFormRef" :key="vi" :model="v">
              <el-form-item prop="value" :rules="genFormItemValueRule(s, v, vi)">
                <div class="del-input-wrap">
                  <template v-if="s.valueConfigRule.measureTemplate && s.valueConfigRule.measureTemplate.length">
                    <el-input
                      :ref="`${sindex}-${vi}`"
                      placeholder="请点击度量衡按钮填写"
                      class="specification-value-flex_input"
                      v-model="v.value"
                      readonly
                      @focus="openMeasureDialog(s, v)"
                    >
                    </el-input>
                  </template>
                  <template v-else-if="s.valueConfigRule.unit && s.valueConfigRule.unit.length">
                    <el-input
                      :ref="`${sindex}-${vi}`"
                      placeholder="请输入"
                      class="specification-value-flex_input"
                      @keyup.enter.native="e => valueEnter(sindex, vi)"
                      @input="e => valueInput(v, s)"
                      v-model="v.extendValues.specValue.value"
                    >
                      <el-select v-model="v.extendValues.specValue.valueUnit" slot="append" placeholder="请选择" width="70px" @change="e => valueInput(v, s)">
                        <el-option
                          v-for="u in s.valueConfigRule.unit"
                          :key="u.unitPropValueId"
                          :label="u.unitPropValueName"
                          :value="u.unitPropValueName"
                        ></el-option>
                      </el-select>
                    </el-input>
                  </template>
                  <el-input
                    v-else
                    :ref="`${sindex}-${vi}`"
                    placeholder="请输入"
                    class="specification-value-flex_input"
                    @keyup.enter.native="e => valueEnter(sindex, vi)"
                    @input="e => valueInput(v, s)"
                    v-model="v.value"
                  >
                  </el-input>
                  <el-checkbox
                    style="margin-left: 8px"
                    v-model="v.checked"
                    @change="e => onChangeCheckbox(v)"
                    :disabled="v.checked && s.values.filter(item => item.checked).length === 1"
                  ></el-checkbox>
                  <drag-item-content></drag-item-content>
                </div>
              </el-form-item>
              <el-form-item
                v-if="s.valueConfigRule.remarkRule && s.valueConfigRule.remarkRule.supportRemark"
                prop="note"
                :rules="genFormItemRemarkRule(s, v)"
              >
                <div class="remarkWrap">
                  <el-input
                    class="input-remark"
                    :ref="`${sindex}-${vi}-remark`"
                    placeholder="规格备注"
                    @input="e => remarkInput(v)"
                    v-model="v['note']"
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item v-if="sindex === 0" prop="imageUrl" :rules="genFormItemImgRule(v, s, `${sindex}-${vi}-img`)">
                <div class="specification-value-flex_img">
                  <ImgUpload
                    :ref="`${sindex}-${vi}-img`"
                    :class="{ 'is-error': imgErrMsgs[`${sindex}-${vi}-img`] }"
                    :width="80"
                    :height="80"
                    :size="150"
                    :aspectRatio="isCheckImg ? 1 : 0"
                    aspectRatioText="1:1"
                    limitSuffix=".png,.jpg,.jpeg"
                    :limitSize=" isCheckImg ?2 * 1024 * 1024 : 0"
                    :file="v.imageUrl === '/resources/css/build/images/no_pic.png' ? '' : v.imageUrl"
                    @upload-success="url => imageUploadSuccess(url, v, sindex, vi)"
                    @del="() => imageUploadDel(v, sindex, vi)"
                    :isSingle="true"
                    :autoCropImageParams="{targetWidth:800,targetHeight:800}"
                  />
                  <div v-if="imgErrMsgs[`${sindex}-${vi}-img`]" class="el-form-item__error">
                    {{ imgErrMsgs[`${sindex}-${vi}-img`] }}
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </vue-draggable>
        <div class="tips ft-12 ml-70" v-if="sindex === 0" style="color: #ccc">
          <span>默认取商品第一张主图，买家选择不同规格会看到对应规格图片，图片大小不超过2M，长宽比为1:1，建议尺寸：800 x 800像素，建议格式：png，jpg，jpeg格式</span>
        </div>
      </div>
    </div>
    <BatchSetSpecRemarksDialog ref="batchSetSpecRemarksDialogRef"/>
    <MeasureInfoDialog ref="measureInfoDialogRef" />
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';
import BatchSetSpecRemarksDialog from '@/components/prod/center/components/BaseInfoForm/components/BatchSetSpecRemarksDialog.vue';
import { dragItemMixin } from '../../utils/mixins';
import { getBytesCount } from '@utils/data';
import { cloneDeep } from 'lodash';
import MeasureInfoDialog from './MeasureInfo.vue';

export default {
  inject: {
    isGroupPuhuo: {
      default: false,
    },
  },
  components: {
    ImgUpload,
    MeasureInfoDialog,
    BatchSetSpecRemarksDialog,
  },
  mixins: [dragItemMixin],
  model: {
    prop: 'values',
    event: 'change',
  },
  props: {
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    changeToBase: {
      // 打开基础资料编辑
      type: Function,
      default: () => {},
    },
    isCheckImg:{
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      specifications: [],
      showAddSkuTips: true,
      imgErrMsgs: {},
      remarkKey: 'note'
    };
  },
  computed: {},
  watch: {
    values: {
      handler(v) {
        this.specifications = v;
      },
      immediate: true,
    }
  },
  mounted() {
    const noTips = localStorage.getItem('noSecTips');
    if (noTips === '1') {
      this.showAddSkuTips = false;
    }
  },
  methods: {
    openMeasureDialog(s, v) {
      this.$refs.measureInfoDialogRef.method_open({
        measureTemplates: s.valueConfigRule.measureTemplate,
        formData: cloneDeep(v),
        okFn: (result) => {
          this.$set(v, 'value', result.value);
          if (!v.extendValues) this.$set(v, 'extendValues', {});
          this.$set(v.extendValues, 'kuaishouMeasureInfo', result.kuaishouMeasureInfo);
        }
      });
    },
    openBatchRemarkDialog(name) {
      this.$refs.batchSetSpecRemarksDialogRef.method_open({
        name,
        remarkKey: this.remarkKey || 'note',
        specifications: this.specifications,
        sureFn: (specs) => {
          this.$emit('change', JSON.parse(JSON.stringify(specs)));
        },
      });
    },
    // 属性备注输入事件
    remarkInput(v) {
      this.$set(v, 'isEdited', true)
      window.__spcificationRemark_changed = true; // 用于skuList生成时的图片取值规则
    },
    // 规格名回车事件
    nameEnter(sindex) {
      let firstInputVm = this.$refs[`${sindex}-0`]; // 当前规格下的第一个规格值输入框
      firstInputVm = firstInputVm ? firstInputVm[0] : firstInputVm;
      if (firstInputVm) {
        firstInputVm.focus();
      }
    },
    nameChange(s) {
      this.$set(s, 'isEdited', true)
    },
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`];
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm;
      if (nextInputVm) {
        // 聚焦到下一个
        nextInputVm.focus();
      }
    },
    async validate() {
      const specificationValid = await this.validateSpecForm();
      if (!specificationValid) {
        return false;
      }
      return true;
    },
    validateSpecForm() {
      const valueForms = this.$refs.specFormRef;
      const skuForms = this.$refs.skuForm || [];
      return new Promise(resolve => {
        if (!valueForms || valueForms.length === 0) {
          resolve(true);
          return false;
        }
        const promiseList = valueForms.concat(Array.isArray(skuForms) ? skuForms : [skuForms]).map(item => {
          return new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            });
          });
        });
        Promise.all(promiseList)
          .then(results => {
            const allValid = results.every(result => result);
            resolve(allValid);
          })
          .catch(() => {
            console.log('validateSpecForm has Error');
            resolve(false);
          });
      });
      console.log(allpro, '----allpro--')
    },
    genFormItemValueRule(specItem, v, vi) {
      const textRule = specItem.valueConfigRule.textRule || {};
      const maxLength = textRule.maxLength;
      let valueValidator = (rule, value, callback) => {
        // if (v.checked) {
          // 度量衡校验
          if (specItem.valueConfigRule.measureTemplate && specItem.valueConfigRule.measureTemplate.length) {
            if (!v.value) {
              return callback(new Error('请填写规格值'));
            }
            const { kuaishouMeasureInfo = {} } = v.extendValues || {};
            const { value = [] } = kuaishouMeasureInfo;

            for (let i = 0; i < value.length; i++) {
              const measureItem = value[i];
              // 跳过操作符类型的校验
              if (measureItem.type === 'OPERATOR') continue;

              // 校验度量衡项值
              if (!measureItem.value) {
                return callback(new Error('请完善度量衡项值'));
              }

              // 校验度量衡单位值 — 从模板 comp 中获取 textRule
              const compItem = specItem.valueConfigRule.measureTemplate
                .find(t => t.templateId === kuaishouMeasureInfo.templateId)?.comp?.[i];
              const hasUnit = compItem?.textRule?.unit?.length > 0;
              if (hasUnit && !measureItem.unitValueId) {
                return callback(new Error('请完善度量衡项值'));
              }
            }
          } else {
            // 原有的普通规格值校验
            if (value) {
              const findItem = specItem.values.find((item, i) => item.value === value && i !== vi);
              if (findItem) {
                return callback(new Error('请勿输入相同规格值'));
              }
              if (maxLength && getBytesCount(value) > maxLength) {
                return callback(new Error(`最多输入${maxLength}字符`));
              }
            }
          }
        // }
        callback();
      };
      return [{ required: v.checked, message: '规格值必填' }, { validator: valueValidator }];
    },
    genFormItemRemarkRule(specItem, v) {
      const remarkRule = specItem.valueConfigRule.remarkRule || {};
      const maxLength = remarkRule.maxLength;
      // 备注长度校验
      let valueValidator = (rule, value, callback) => {
        // if (v.checked) {
          if (maxLength && getBytesCount(value) > maxLength) {
            return callback(new Error(`备注不超过${maxLength}个字符`));
          }
        // }
        callback();
      };
      return [{ validator: valueValidator }];
    },
    genFormItemImgRule(v, specItem, ref) {
      let valueValidator = async (rule, value, callback) => {
        // if (v.checked) {
          const refImg = this.$refs[ref];
          if (v.imageUrl && refImg && refImg[0]) {
            let errMsg = await refImg[0].method_validImage();
            if (errMsg) {
              return callback(new Error(errMsg));
            } else {
              callback();
            }
          }
        // }
        callback();
      };
      return [
        {
          required: true,
          validator: valueValidator,
        },
      ];
    },

    valueInput(v, s) {
      this.$set(v, 'isEdited', true)
      if(s?.valueConfigRule?.unit?.length) {
        v.value = v.extendValues.specValue.value + v.extendValues.specValue.valueUnit
      }
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
      this.$emit('fieldChanged');
    },
    onChangeCheckbox(v) {
      this.$set(v, 'isEdited', true)
      window.__spcificationCheckbox_changed = true;
      this.$emit('fieldChanged');
    },

    imageUploadSuccess(url, v, sindex, vi) {
      this.$set(v, 'isEdited', true)
      this.checkImgError && this.checkImgError(); // 淘宝用的
      v.imageUrl = url;
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('file-upload', url);
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v, sindex, vi) {
      this.$set(v, 'isEdited', true)
      v.imageUrl = '';
      this.checkImgError && this.checkImgError(); // 淘宝用的

      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    handleNoTips() {
      this.showAddSkuTips = false;
      localStorage.setItem('noSecTips', 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #dcdfe6;

  .input-value {
    display: inline-block;
  }
  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
  // ::v-deep .el-input input {
  //   background: #F8F8F8 !important;
  // }
}

.specification-value {
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    position: relative;
    top: -16px;
    &_item {
      margin-right: 10px;
      margin-bottom: 15px;
    }
    &_img {
      width: 100%;
      margin-top: 10px;
      position: relative;
    }
    .el-input,
    .el-select {
      width: 160px;
    }
  }
  ::v-deep .el-form-item__error {
    position: relative;
  }
}
.del-input-wrap {
  position: relative;
  padding-right: 10px;
  .input-remark {
    margin-left: 10px;
  }
}
.remarkWrap {
  margin-top: 5px;
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
</style>